import { getTestIds } from '../../utils/TestIds';
export { GetRichTextEditorTID } from './tokens/tokenTestIds';
export const GetMobileRichTextEditorTID = (parentTestId)=>getTestIds(parentTestId);
export const { MobileRichTextEditorTID } = GetMobileRichTextEditorTID();
